import { once } from 'lodash'
import { validate as isUuid } from 'uuid'

import { logGetStartedEvent } from './log'

const logPromo = once(() => logGetStartedEvent('CampaignOrPromo'))

function setOrgData(changeOrg, orgId, type, value) {
  if (isUuid(orgId) && value && value !== '_') {
    value = JSON.stringify({ value })
    changeOrg({
      variables: {
        data: { orgId, type, value }
      }
    })
  }
}

export function setPromo(changeOrg, orgId, promo) {
  logPromo()
  setOrgData(changeOrg, orgId, 'promo', promo)
}

export function saveNotes(changeOrg, orgId, notes) {
  setOrgData(changeOrg, orgId, 'notes', notes)
}
